import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/solution-box.css'

/**
 *  Box-like component for displaying Work Product solutions.
 *  Similar to SolutionRow component, but has more options like a Neutral state and
 *  the ability to chain multiple boxes together (mainly for displaying Argument Builder arguments).
 */
const SolutionBox = props => {
  const { type, title, subtitle, percentage, text, firstBridge, secondText, secondBridge, thirdText } = props

  return(
    <div className={`solution-box ${type} ${!!percentage ? 'percentage' : ''}`}>
      <div className='top-border'>
        <div className='title'>{title}</div>
        {subtitle && <div className='subtitle'>{subtitle}</div>}
        {!!percentage && [
          <div key='percentage' className='percentage'>
            <div className='percentage-contents'>
              <span>{parseInt(percentage*100)}%</span>
            </div>
          </div>,
          <div key='fudgebox' className='percentage-fudge-box'/>
        ]}
      </div>
      <div className='text-boxes'>
        <div className='text-container'>
          {text}
        </div>
        {secondText &&
          <div className='text-container'>
            <div className='bridge-container'>
              <div className='bridge'>
                <div className='bridge-word'>{firstBridge}</div>
              </div>
            </div>
            {secondText}
          </div>
        }
        {thirdText &&
          <div className='text-container'>
            <div className='bridge-container'>
              <div className='bridge'>
                <div className='bridge-word'>{secondBridge}</div>
              </div>
            </div>
            {thirdText}
          </div>
        }
      </div>
    </div>
  )
}

SolutionBox.propTypes = {
  /** Either correct, incorrect, or neutral. Determines the coloring of the component. */
  type: PropTypes.oneOf(['correct', 'incorrect', 'neutral']).isRequired,
  /** The percentage to display in the top-right corner. Should be an integer. */
  percentage:   PropTypes.number,
  /** The text that the box displays */
  text:         PropTypes.string.isRequired,
  /** If a second box is being displayed, bridge text can be used to connect the first and second box */
  firstBridge:  PropTypes.string,
  /** Text to display in the second box */
  secondText:   PropTypes.string,
  /** If a third box is being displayed, bridge text can be used to connect the second and third box*/
  secondBridge: PropTypes.string,
  /** Text to display in the third box */
  thirdText:    PropTypes.string
}

export default SolutionBox
